/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PaperPot, PaperPotInterface } from "../PaperPot";

const _abi = [
  {
    inputs: [
      {
        internalType: "address[]",
        name: "seedContractAddresses",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "sadSeeds",
        type: "uint256[]",
      },
      {
        internalType: "string[3]",
        name: "resourceUris_",
        type: "string[3]",
      },
      {
        internalType: "address",
        name: "metadataGenerator_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "growthAmount",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "growthBps",
        type: "uint16",
      },
    ],
    name: "Grow",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Happy",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "pottedPlantTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shrubTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Harvest",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "seedTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Plant",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "SEED_CONTRACT_ADDRESSES",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_metadataGenerator",
    outputs: [
      {
        internalType: "contract IPaperPotMetadata",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_seedContractAddress",
        type: "address",
      },
    ],
    name: "addSeedContractAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "adminDistributeFertilizer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "adminDistributeWater",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
    ],
    name: "adminEmitUri",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "adminMintPot",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "fertForHappy_",
        type: "uint256",
      },
    ],
    name: "adminSetFertForHappy",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "fertForName_",
        type: "uint256",
      },
    ],
    name: "adminSetFertForName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "freeze_",
        type: "bool",
      },
    ],
    name: "adminSetFreeze",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "seedTokenIds",
        type: "uint256[]",
      },
      {
        internalType: "bool[]",
        name: "isSads",
        type: "bool[]",
      },
    ],
    name: "adminSetSadSeeds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_tokenIds",
        type: "uint256[]",
      },
    ],
    name: "eligibleForWatering",
    outputs: [
      {
        internalType: "bool",
        name: "eligible",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "getGrowthLevel",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "getLastWatering",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "getPlantedSeed",
    outputs: [
      {
        internalType: "uint256",
        name: "seedTokenId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "harvest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "seedTokenId_",
        type: "uint256",
      },
    ],
    name: "isSeedSad",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ticketTokenId",
        type: "uint256",
      },
    ],
    name: "mintFromTicket",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mintingPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "p",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "pauseMinting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_seedContractAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_seedTokenId",
        type: "uint256",
      },
    ],
    name: "plant",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_seedContractAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_seedTokenId",
        type: "uint256",
      },
    ],
    name: "plantAndMakeHappy",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "pottedPlantCurrentIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum NftClass",
        name: "",
        type: "uint8",
      },
    ],
    name: "pottedPlantsByClass",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_seedContractAddress",
        type: "address",
      },
    ],
    name: "removeSeedContractAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "bool",
        name: "add",
        type: "bool",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_contractUri",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "metadataGenerator_",
        type: "address",
      },
    ],
    name: "setMetadataGenerator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "NFTTicketTokenId_",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "NFTTicketAddress_",
        type: "address",
      },
    ],
    name: "setNftTicketInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "bps",
        type: "uint256",
      },
    ],
    name: "setRoyalties",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "newName_",
        type: "string",
      },
    ],
    name: "setShrubName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "tokenURI_",
        type: "string",
      },
    ],
    name: "setURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "shrubCurrentIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpauseMinting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_tokenIds",
        type: "uint256[]",
      },
    ],
    name: "water",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_tokenIds",
        type: "uint256[]",
      },
    ],
    name: "waterWithFertilizer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type PaperPotConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PaperPotConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class PaperPot__factory extends ContractFactory {
  constructor(...args: PaperPotConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    seedContractAddresses: string[],
    sadSeeds: BigNumberish[],
    resourceUris_: [string, string, string],
    metadataGenerator_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PaperPot> {
    return super.deploy(
      seedContractAddresses,
      sadSeeds,
      resourceUris_,
      metadataGenerator_,
      overrides || {}
    ) as Promise<PaperPot>;
  }
  getDeployTransaction(
    seedContractAddresses: string[],
    sadSeeds: BigNumberish[],
    resourceUris_: [string, string, string],
    metadataGenerator_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      seedContractAddresses,
      sadSeeds,
      resourceUris_,
      metadataGenerator_,
      overrides || {}
    );
  }
  attach(address: string): PaperPot {
    return super.attach(address) as PaperPot;
  }
  connect(signer: Signer): PaperPot__factory {
    return super.connect(signer) as PaperPot__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PaperPotInterface {
    return new utils.Interface(_abi) as PaperPotInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PaperPot {
    return new Contract(address, _abi, signerOrProvider) as PaperPot;
  }
}
